import React from "react";
import "./Toast.scss";
const Toast = (props: { message: string }) => {
  return (
    <div className="toast row">
      <div className="col-3 text-center">
        <i className={`mdi mdi-48px icon`} />
      </div>
      <div className="col-9 pl-0">
        <div className="message d-flex flex-column justify-content-center h-100 py-2">
          {props.message}
        </div>
      </div>
    </div>
  );
};

export default Toast;
